import { PaymentService } from '@/app/services/payments'
import { ErrorResponse, IApiIndividualResponse } from '@/types/api'
import { INewCheckoutPayload, INewCheckoutResponse } from '@/types/payment'
import { useMutation, UseMutationOptions } from 'react-query'

export function useCheckout(
  opts?: Omit<
    UseMutationOptions<
      IApiIndividualResponse<INewCheckoutResponse>,
      ErrorResponse,
      INewCheckoutPayload
    >,
    'queryKey' | 'queryFn'
  >
) {
  return useMutation<
    IApiIndividualResponse<INewCheckoutResponse>,
    ErrorResponse,
    INewCheckoutPayload
  >([PaymentService.POST_CHECKOUT_PATH], PaymentService.checkout, opts)
}
